/**
 * Converts a zero-based index to an alphabetical label (A, B, C, ..., Z, AA, AB, ...).
 * @param {number} index - The zero-based index to convert.
 * @returns {string} The corresponding alphabetical label.
 */
export const toAlphaLabel = (index) => {
    let label = '';
    index += 1;
    while (index > 0) {
        let remainder = (index - 1) % 26;
        label = String.fromCharCode(65 + remainder) + label;
        index = Math.floor((index - 1) / 26);
    }
    return label;
};
